import { makeStyles, IconButton } from '@material-ui/core';
import RepeatIcon from '@mui/icons-material/Repeat';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { dateToPosition } from '~/modules/common/charts/timeline/calculations';
import { mapIsoStringtoUtcObject } from '~/modules/common/dates/convert';

const useStyles = makeStyles(theme => ({
  repeatIconButton: ({ repeatIconPosition }) => ({
    position: 'absolute',
    left: repeatIconPosition + theme.spacing(0.5),
    top: -theme.spacing(1),
    width: theme.spacing(3),
    height: theme.spacing(3),
    padding: theme.spacing(0.375),
    borderRadius: theme.spacing(0.5),
    opacity: 0,
    zIndex: 10,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[4],
    '&:hover': {
      backgroundColor: theme.palette.grey[100]
    }
  })
}));

const getRepeatIconPosition = ({
  resourceAllocation,
  chartDisplayDateRange,
  scale
}) => {
  const allocationEndDate = mapIsoStringtoUtcObject(resourceAllocation.endDate);

  return dateToPosition({
    chartStartDate: chartDisplayDateRange.startDate,
    date: allocationEndDate.plus({ days: 1 }),
    scale,
    isPsaRmpUserSchedulePerfFixEnabled: true
  });
};

const SetResourceAllocationRepeatButton = ({
  className,
  resourceAllocation,
  chartDisplayDateRange,
  scale,
  onClick
}) => {
  const repeatIconPosition = getRepeatIconPosition({
    resourceAllocation,
    chartDisplayDateRange,
    scale
  });

  const classes = useStyles({ repeatIconPosition });

  if (repeatIconPosition === null) return null;

  return (
    <IconButton
      className={classNames(classes.repeatIconButton, className)}
      onClick={onClick}
      size="small"
      data-qe-id="SetResourceAllocationRepeatButton"
      tabIndex={-1}
    >
      <RepeatIcon />
    </IconButton>
  );
};

SetResourceAllocationRepeatButton.propTypes = {
  className: PropTypes.string,
  resourceAllocation: PropTypes.object.isRequired,
  chartDisplayDateRange: PropTypes.object.isRequired,
  scale: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default SetResourceAllocationRepeatButton;
